module.exports = __webpack_public_path__ + "media/images/site-section/newsletter-background-a6538acd1e56375b47f4cb5d1329fac4.jpg";